import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { MyHttpClient } from '../../app/http-client.service';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HostDetailsService {

  constructor(private http: MyHttpClient) { }
  server = `${environment.server}`;
  getHost = this.server + '/api/getHostByMobile';

  getHostByMobile(mobile) {
    return this.http.get(this.getHost + '/' + mobile).pipe(catchError(this.handleError));
  }

  getHostWalletBalance(profileId: string) {
    const url = `${this.server}/api/wallet/host/${profileId}/walletBalance`;
    return this.http.get(url).pipe(catchError(this.handleError));
  }

  getReferralTracking(profileId: string, limit = 20, offset = 0) {
    const url = `${this.server}/api/pool-manager/profiles/${profileId}/referrals/tracking?limit=${limit}&offset=${offset}`;
    return this.http.get(url).pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError(error);
  }
}
